<nav class="navbar mb-5 bg-transparent navbar-dark navbar-expand-lg justify-content-between">
  <a class="navbar-brand" [routerLink]="['/']">
    <img src="../../../../../assets/images/logo_rnt-w.png" class="d-inline-block align-top img-responsive" height="32"
      alt="">
    Registro Nacional de Turismo
  </a>
  <button class="navbar-toggler" type="button" (click)="isNavbarCollapsed = !isNavbarCollapsed"
    data-target="#navbarsDefault" aria-controls="navbarsDefault" aria-expanded="false" aria-label="Toggle navigation">
    <span class="navbar-toggler-icon"></span>
  </button>
  <div class="collapse navbar-collapse flex-grow-0" [ngbCollapse]="isNavbarCollapsed">
    <div class="navbar-nav">
      <!-- FIXME: comentar lineas al finalizar pruebas -->
      <div ngbDropdown>
        <a class="nav-item nav-link text-white m-3 pointer" id="dropdownConfig" ngbDropdownToggle>Prestadores de
          Servicios
          Turísticos</a>
        <div ngbDropdownMenu aria-labelledby="dropdownConfig" class="w-100">
          <button class="dropdown-item" [routerLink]="['/establecimientos']">Consulta de RNTS</button>
          <button class="dropdown-item" [routerLink]="['/reportes']">Reportes</button>
        </div>
      </div>
      <!--#endregion-->
      <!-- <a class="nav-item nav-link text-white m-3" [routerLink]="['/establecimientos']">
        <span>Consulta de RNTS</span>
      </a> -->
      <a class="nav-item nav-link text-white m-3" [routerLink]="['/contactenos']">
        <span>Contáctenos</span>
      </a>
      <a class="nav-item nav-link text-white m-3" [routerLink]="['/faq']">
        <span>Más información</span>
      </a>
      <a *ngIf="!location.isCurrentPathEqualTo('/login')" class="nav-item nav-link text-white m-3"
        [routerLink]="['/login']">
        <span>Iniciar sesión</span>
      </a>
      <a *ngIf="!location.isCurrentPathEqualTo('/registrar')"
        class="nav-item nav-link btn text-white m-3 pl-4 pr-4 menu-color-registrarse" [routerLink]="['/registrar']">
        <span>Registrarse</span>
      </a>
    </div>
  </div>
</nav>
<ng-content></ng-content>
<nav class="navbar navbar-light shadow-sm footer border-top menu-color-nav-footer p-2"
  [ngClass]="!location.isCurrentPathEqualTo('/home') ? 'fixed-bottom' : ''">
  <footer class="col-sm-12 text-center">
    <address class="text-white m-0 small mr-2">
      <a class="text-muted ol pointer" (click)="onOLClick()" style="cursor: pointer;">&copy; Confec&aacute;maras</a>
       | Red de c&aacute;maras de comercio - {{year|date:'y'}}</address>
       <label style="color: white;font-size: x-small; ">version:01.15.2025 -Rev(2)</label>
  </footer>
</nav>
